import React, { useEffect, useState } from 'react';
import { Button, ButtonToolbar, Table } from 'rsuite';
import { Link } from 'react-router-dom';
import { getTransformations } from '../services/TransformationsService';
import DeleteTransformationAlert from './DeleteTransformationAlert';
import { TransformationResponseDto } from '../services/ApiType';
import { baseUrl } from '../Configuration';

const { Column, HeaderCell, Cell } = Table;

interface ActionsProps {
  transformation: TransformationResponseDto,
  onDelete: () => void;
}

function getTransformationUrl(transformation: TransformationResponseDto): string {
  return `${baseUrl}/public/transformations/${transformation.id}/transform`;
}

function Actions({ transformation, onDelete }: ActionsProps) {
  const transformationUrl = getTransformationUrl(transformation);

  return (
    <ButtonToolbar>
      <a
        href={transformationUrl}
        target="_blank"
        download
        type="application/xml"
        rel="noreferrer"
      >
        <Button
          size="sm"
          appearance="default"
        >
          Download
        </Button>
      </a>
      <Link to={`/transformations/${transformation.id}/edit`}>
        <Button
          size="sm"
          color="blue"
          appearance="primary"
        >
          Edit
        </Button>
      </Link>
      <Button
        size="sm"
        color="red"
        appearance="primary"
        onClick={() => onDelete()}
      >
        Delete
      </Button>
    </ButtonToolbar>
  );
}

function TransformationsTable() {
  const [transformations, setTransformations] = useState<TransformationResponseDto[]>([]);
  const [
    deletingTransformation,
    setDeletingTransformation,
  ] = useState<TransformationResponseDto | undefined>(undefined);
  const [
    isDeleteTransformationAlertOpen,
    setIsDeleteTransformationAlertOpen,
  ] = useState<boolean>(false);

  const fetchTransformations = () => {
    getTransformations()
      .then((data) => setTransformations(data));
  };

  useEffect(() => {
    fetchTransformations();
  }, []);

  return (
    <>
      <Table height={600} fillHeight rowHeight={60} data={transformations} showHeader>
        <Column flexGrow={5} verticalAlign="middle">
          <HeaderCell>Id</HeaderCell>
          <Cell dataKey="id" />
        </Column>
        <Column flexGrow={40} verticalAlign="middle" fullText>
          <HeaderCell>XML Url</HeaderCell>
          <Cell dataKey="xmlUrl" />
        </Column>
        <Column flexGrow={40} verticalAlign="middle" fullText>
          <HeaderCell>Transformation Url</HeaderCell>
          <Cell>
            {transformation => getTransformationUrl(transformation as TransformationResponseDto)}
          </Cell>
        </Column>
        <Column flexGrow={40} verticalAlign="middle" fullText>
          <HeaderCell>Transformation name</HeaderCell>
          <Cell dataKey="name" />
        </Column>
        <Column flexGrow={30} verticalAlign="middle">
          <HeaderCell>Actions</HeaderCell>
          <Cell>
            {transformation => (
              <Actions
                transformation={transformation as TransformationResponseDto}
                onDelete={
                  () => {
                    setDeletingTransformation(transformation as TransformationResponseDto);
                    setIsDeleteTransformationAlertOpen(true);
                  }
              }
              />
            )}
          </Cell>
        </Column>
      </Table>
      {
          deletingTransformation
          && (
          <DeleteTransformationAlert
            transformation={deletingTransformation}
            open={isDeleteTransformationAlertOpen}
            onClose={() => {
              setDeletingTransformation(undefined);
              setIsDeleteTransformationAlertOpen(false);
            }}
            onSuccess={() => fetchTransformations()}
          />
          )
      }
    </>
  );
}

export default TransformationsTable;
